//App.js
import { Suspense, useState, useEffect, useCallback } from "react";
//Contexts
import { AuthContext } from "./shared/context/auth-context";
import { NotificationsProvider } from "./shared/context/notification-context";
import { ClinicaContext } from "./shared/context/clinica-context";
import { LoadingProvider } from "./shared/context/LoadingContext";
import { WebSocketProvider } from "./shared/context/websocket-context";
import { ActiveDoctorsProvider } from "./shared/context/active-doctors-context";
import { TutorialProvider } from "./shared/context/TutorialProvider";
import { ChatProvider } from "./shared/context/chat-context";
import { ContingenciaEfaturaProvider } from "./shared/context/contingencia-efatura-context";

//Dashboard
import HomeMedicoAdministrador from "./pages/home/medicoAdministrador/HomeMedicoAdministrador";
import HomeDentista from "./pages/home/dentista/HomeDentista";
import HomeSecretaria from "./pages/home/secretaria/HomeSecretaria";
import HomeAdministrativo from "./pages/home/administrativo/HomeAdministrativo";
import HomeAssistente from "./pages/home/assistente/HomeAssistente";

// CLientes
import New from "./pages/clientes/new/New";
import Clientes from "./pages/clientes/clientes/Clientes";
import Single from "./pages/clientes/single/Single";
import Edit from "./pages/clientes/edit/Edit";

// Funcionarios
import NewFuncionario from "./pages/funcionarios/new/New";
import Funcionarios from "./pages/funcionarios/funcionarios/Funcionarios";
import EditFuncionario from "./pages/funcionarios/edit/Edit";

// Anamnese
import NewAnamnese from "./pages/clientes/components/anamnese/new/NewAnamnese";
import EditAnamnese from "./pages/clientes/components/anamnese/edit/EditAnamnese";

// Tratamentos
import NewTratamento from "./pages/tratamentos/new/NewTratamento";
import Tratamentos from "./pages/tratamentos/tratamentos/Tratamentos";
import EditTratamento from "./pages/tratamentos/edit/EditTratamento";

// Plano de Tratamento
import ExecutarPlanoTratamento from "./pages/planoTratamento/executar/ExecutarPlanoTratamento";

// Avaliacao
import NewAvaliacao from "./pages/avaliacoes/new/NewAvaliacao";
import EditAvaliacao from "./pages/avaliacoes/edit/EditAvaliacao";

// Orcamentos
import NewOrcamento from "./pages/orcamentos/new/NewOrcamento";
import NewOrcamentoDireto from "./pages/orcamentos/newOrcamentoDireto/NewOrcamentoDireto";

// Agendamentos
import Agendamentos from "./pages/agendamentos/agendamentos/Agendamentos";
import AgendamentosTratamento from "./pages/agendamentos/agendamentos/AgendamentosTratamento";

import AgendamentosViewOnly from "./pages/agendamentos/agendamentos/AgendamentosViewOnly";
import AgendamentosTratamentoViewOnly from "./pages/agendamentos/agendamentos/AgendamentosTratamentoViewOnly";
import PedidosMarcacao from "./pages/pedidosMarcacao/PedidosMarcacao";

// Configuracoes
import Configuracoes from "./pages/configuracoes/Configuracoes";

// Manutenção
import Manutencao from "./pages/manutencao/Manutencao";

//Financeiro
import Financeiro from "./pages/financeiro/Financeiro";
import Relatorios from "./pages/relatorios/Relatorios";

//Confirmacao presenca
import ConfirmacaoPresenca from "./pages/confirmacaoPresenca/ConfirmacaoPresenca";

//USERS
import Users from "./pages/users/Users";
// import EditUser from "./pages/users/edit/EditUser";
import SingleUser from "./pages/users/single/SingleUser";
// import NewUser from "./pages/users/new/NewUser";

//Prescricoes
import NewPrescricao from "./pages/prescricoes/new/NewPrescricao";

//Prescricoes
import Stock from "./pages/stock/Stock";

//Requisição exames
import RequisicaoExames from "./pages/RequisicaoExames/RequisicaoExames";
//Logs
import Logs from "./pages/logs/Logs";

//Lista Espera
import ListaEspera from "./pages/listaEspera/ListaEspera";

import "./style/global.scss";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Auth from "./pages/users/auth/Auth";

import { useAuth } from "./shared/hooks/auth-hook";
import { useHttpClient } from "./shared/hooks/http-hook";

import PageNotFound from "./pages/pageNotFound/PageNotFound";

import HomeAdministradorNaoMedico from "./pages/home/administradorNaoMedico/HomeAdministradorNaoMedico";

import NewImpresso from "./pages/impressos/new/NewImpresso";

import LoadingSpinner from "./shared/components/UIElements/LoadingSpinner";
import BarraUrgencias from "./shared/components/barraUrgencias/BarraUrgencias";

import NovaClinicaForm from "./pages/clinica/NovaClinicaForm";

//Release Notes
import ReleaseNotes from "./pages/releaseNotes/ReleaseNotes";

import { WhatsAppManager } from "./shared/components/whatsapp/WhatsAppManager";
import { VersionCheckProvider } from "./shared/context/version-check-context";
// Lazy loaded components
//Funcionarios lazy loaded
// const Funcionarios = lazy(() =>
//   import("./pages/funcionarios/funcionarios/Funcionarios")
// );
// const NewFuncionario = lazy(() => import("./pages/funcionarios/new/New"));
// const EditFuncionario = lazy(() => import("./pages/funcionarios/edit/Edit"));
// const VerFuncionario = lazy(() => import("./pages/funcionarios/ver/Ver"));

// //Users Lazy Loaded
// const Users = lazy(() => import("./pages/users/Users"));
// const EditUser = lazy(() => import("./pages/users/edit/EditUser"));
// const SingleUser = lazy(() => import("./pages/users/single/SingleUser"));
// const NewUser = lazy(() => import("./pages/users/new/NewUser"));

// //Anamnese Lazy Loaded
// const NewAnamnese = lazy(() =>
//   import("./pages/clientes/components/anamnese/new/NewAnamnese")
// );
// const EditAnamnese = lazy(() =>
//   import("./pages/clientes/components/anamnese/edit/EditAnamnese")
// );

// //Tratamentos Lazy Loaded
// const NewTratamento = lazy(() =>
//   import("./pages/tratamentos/new/NewTratamento")
// );
// const Tratamentos = lazy(() =>
//   import("./pages/tratamentos/tratamentos/Tratamentos")
// );
// const EditTratamento = lazy(() =>
//   import("./pages/tratamentos/edit/EditTratamento")
// );

// // Clincias Lazy Loaded
// const Clinicas = lazy(() => import("./pages/clinicas/clinicas/Clinicas"));
// const SingleClinica = lazy(() =>
//   import("./pages/clinicas/single/SingleClinica")
// );
// const EditClinica = lazy(() => import("./pages/clinicas/edit/EditClinica"));
// const NewClinica = lazy(() => import("./pages/clinicas/new/NewClinica"));

function App() {
  const {
    token,
    login,
    logout,
    userId,
    image,
    userRole,
    listaRoles,
    clinica,
    usuariosAssociados,
    secretariasDoMedico,
    assistentesDoMedico,
    permissoes,
    nome,
    genero,
    playNotificationSound,
    estabelecimento,
    atualizarEstabelecimento,
  } = useAuth();

  const { sendRequest } = useHttpClient();
  const [configuracoes, setConfiguracoes] = useState(null);

  const fetchConfiguracoes = useCallback(async () => {
    if (!token || !clinica?.clinica?._id) return;
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/configuracoes/clinica/${clinica.clinica._id}`,
        "GET",
        null,
        { Authorization: "Bearer " + token },
      );
      setConfiguracoes(responseData.configuracao);
    } catch (err) {
      console.error("Error fetching configuracoes:", err);
    }
  }, [token, clinica?.clinica?._id, sendRequest]);

  useEffect(() => {
    fetchConfiguracoes();
  }, [fetchConfiguracoes]);

  let routes;

  routes = (
    // <Suspense fallback={<div>Carregando...</div>}>
    <Routes>
      <Route path="/c/:token" element={<ConfirmacaoPresenca />} />
      {permissoes && token ? (
        <>
          <Route path="/">
            {/* Rotas para criar clinica */}
            <Route path="novaclinica">
              <Route index element={<NovaClinicaForm />} />
            </Route>

            {userRole === "Secretária(o)" && (
              <Route path="listaespera">
                <Route index element={<ListaEspera />} />
              </Route>
            )}

            {userRole === "Médico/Administrador" && (
              <Route index element={<HomeMedicoAdministrador />} />
            )}
            {userRole === "Gerente" && (
              <Route index element={<HomeAdministradorNaoMedico />} />
            )}
            {userRole === "Dentista" && (
              <Route index element={<HomeDentista />} />
            )}
            {userRole === "Secretária(o)" && (
              <Route index element={<HomeSecretaria />} />
            )}
            {userRole === "Assistente" && (
              <Route index element={<HomeAssistente />} />
            )}
            {userRole === "Administrativo" && (
              <Route index element={<HomeAdministrativo />} />
            )}
            <Route path="auth" element={<Auth />} />

            <Route
              path="clientes/:clienteId/orcamentoDireto/novo"
              element={<NewOrcamentoDireto />}
            />
            {/* Rota para duplicar orçamento */}
            <Route
              path="clientes/:clienteId/orcamentoDireto/novo/:orcamentoId"
              element={<NewOrcamentoDireto />}
            />

            {/* Rotas para Clientes */}
            {permissoes.includes("r-paCli") && (
              <Route path="clientes">
                <Route index element={<Clientes />} />

                {permissoes.includes("r-cli") && (
                  <Route path=":clienteId">
                    <Route index element={<Single />} />
                    {permissoes.includes("u-cli") && (
                      <Route path="edit" element={<Edit />} />
                    )}
                  </Route>
                )}
                {permissoes.includes("c-cli") && (
                  <Route
                    path="new"
                    element={<New title="Adicionar Novo Cliente" />}
                  />
                )}
              </Route>
            )}
            {/* Rotas para Funcionarios */}
            {(userRole === "Médico/Administrador" ||
              userRole === "Gerente") && (
              <Route path="funcionarios">
                <Route index element={<Funcionarios />} />

                <Route path=":funcionarioId">
                  {/* <Route index element={<SingleFuncionario />} /> */}
                  {permissoes.includes("u-func") && (
                    <Route path="edit" element={<EditFuncionario />} />
                  )}
                </Route>
                {permissoes.includes("c-func") && (
                  <Route
                    path="new"
                    element={
                      <NewFuncionario title="Adicionar Novo Funcionario" />
                    }
                  />
                )}
              </Route>
            )}
            {/* Rotas para Financeiro */}
            {permissoes.includes("r-paFi") && (
              <Route path="financeiro">
                <Route index element={<Financeiro />} />
              </Route>
            )}

            {/* Rotas para relatorios */}
            {permissoes.includes("r-paRel") && (
              <Route path="relatorios">
                <Route index element={<Relatorios />} />
              </Route>
            )}

            {/* Rotas para Anamnese */}
            {(userRole === "Médico/Administrador" ||
              userRole === "Dentista") && (
              <Route path="anamnese">
                <Route path=":clienteId">
                  <Route
                    path="new"
                    element={<NewAnamnese title="Criar Anamnese" />}
                  />
                </Route>
                <Route path=":infos">
                  <Route
                    path="edit"
                    element={<EditAnamnese title="Editar Anamnese" />}
                  />
                </Route>
              </Route>
            )}

            {/* Rotas para Tratamentos */}
            {permissoes.includes("r-paTra") && (
              <Route path="tratamentos">
                <Route index element={<Tratamentos />} />

                <Route path=":tratamentoId">
                  {permissoes.includes("u-tr") && (
                    <Route path="edit" element={<EditTratamento />} />
                  )}
                </Route>
                {permissoes.includes("c-tr") && (
                  <Route
                    path="new"
                    element={
                      <NewTratamento title="Adicionar Novo Tratamento" />
                    }
                  />
                )}
              </Route>
            )}

            {/* Rotas para Plano de Tratamento */}
            <Route path="planotratamento">
              {(userRole === "Dentista" ||
                userRole === "Médico/Administrador") && (
                <Route path="executar">
                  <Route
                    path=":planoTratamentoId"
                    element={<ExecutarPlanoTratamento />}
                  />
                </Route>
              )}
            </Route>

            {/* Rotas para Avaliacoes */}
            <Route path="avaliacao">
              {permissoes.includes("c-aval") &&
                (userRole === "Dentista" ||
                  userRole === "Médico/Administrador" ||
                  userRole === "Secretária(o)" ||
                  userRole === "Assistente") && (
                  <Route path="new">
                    <Route path=":clienteId" element={<NewAvaliacao />} />
                  </Route>
                )}

              {permissoes.includes("u-aval") &&
                (userRole === "Dentista" ||
                  userRole === "Médico/Administrador" ||
                  userRole === "Secretária(o)" ||
                  userRole === "Assistente") && (
                  <Route path="edit">
                    <Route path=":avaliacaoId" element={<EditAvaliacao />} />
                  </Route>
                )}
            </Route>

            {/* Rotas para Orçamentos */}
            <Route path="orcamentos">
              {permissoes.includes("c-orc") &&
                (userRole === "Dentista" ||
                  userRole === "Médico/Administrador" ||
                  userRole === "Secretária(o)" ||
                  userRole === "Assistente") && (
                  <Route path="new">
                    <Route path=":avaliacaoId" element={<NewOrcamento />} />
                  </Route>
                )}

              {/* Edição de orçamento desativada — usar a Substituição de
                  Orçamento. Rota removida intencionalmente. */}
            </Route>

            {/* ==================== AGENDAMENTOS ==================== */}

            {/* MODO ESCRITA - Dentista, Secretária, Assistente podem editar qualquer agenda associada */}
            {permissoes.includes("r-paAg") &&
              permissoes.includes("c-marc") &&
              (userRole === "Dentista" ||
                userRole === "Secretária(o)" ||
                userRole === "Assistente") && (
                <Route path="agendamentos">
                  <Route path=":medicoId" element={<Agendamentos />} />
                </Route>
              )}

            {/* MODO ESCRITA - Médico/Administrador pode editar qualquer agenda */}
            {permissoes.includes("r-paAg") &&
              permissoes.includes("c-marc") &&
              userRole === "Médico/Administrador" && (
                <Route path="agendamentos">
                  <Route path=":medicoId" element={<Agendamentos />} />
                </Route>
              )}

            {/* MODO ESCRITA TRATAMENTO - Dentista, Secretária, Assistente */}
            {permissoes.includes("r-paAg") &&
              permissoes.includes("c-marc") &&
              (userRole === "Dentista" ||
                userRole === "Secretária(o)" ||
                userRole === "Assistente") && (
                <Route path="agendamentostratamento">
                  <Route
                    path=":medicoId"
                    element={<AgendamentosTratamento />}
                  />
                </Route>
              )}

            {/* MODO ESCRITA TRATAMENTO - Médico/Administrador pode editar qualquer agenda */}
            {permissoes.includes("r-paAg") &&
              permissoes.includes("c-marc") &&
              userRole === "Médico/Administrador" && (
                <Route path="agendamentostratamento">
                  <Route
                    path=":medicoId"
                    element={<AgendamentosTratamento />}
                  />
                </Route>
              )}

            {/* VIEW ONLY - Agendamentos Normais */}
            {permissoes.includes("r-paAg") && (
              <Route path="agendamentosviewonly">
                <Route path=":medicoId" element={<AgendamentosViewOnly />} />
              </Route>
            )}

            {/* VIEW ONLY - Agendamentos Tratamento */}
            {permissoes.includes("r-paAg") && (
              <Route path="agendamentostratamentoviewonly">
                <Route
                  path=":medicoId"
                  element={<AgendamentosTratamentoViewOnly />}
                />
              </Route>
            )}

            {/* Pedidos vindos da página pública de marcações. Quem pode criar
                marcações pode decidi-los — é a mesma operação, feita a partir
                de um pedido em vez de um telefonema. */}
            {permissoes.includes("c-marc") && (
              <Route path="pedidosmarcacao" element={<PedidosMarcacao />} />
            )}

            {/* ==================== Configurações ==================== */}
            {(userRole === "Gerente" ||
              userRole === "Médico/Administrador") && (
              <Route path="configuracoes">
                <Route path=":aba" element={<Configuracoes />} />
                {/* <Route index element={<Configuracoes />} /> */}
              </Route>
            )}

            {/* ==================== Manutenção ==================== */}
            {userRole !== "Assistente" && (
              <Route path="manutencao">
                <Route index element={<Manutencao />} />
                <Route path=":aba" element={<Manutencao />} />
              </Route>
            )}

            {/* Rotas para Prescricoes */}
            {permissoes.includes("c-pres") && (
              <Route path="prescricao">
                <Route path=":clienteId">
                  <Route index element={<NewPrescricao />} />
                </Route>
              </Route>
            )}

            {/* Rotas para Requisição de exames */}
            {(userRole === "Dentista" ||
              userRole === "Médico/Administrador") && (
              <Route path="requisicaoexames">
                <Route path=":clienteId">
                  <Route index element={<RequisicaoExames />} />
                </Route>
              </Route>
            )}

            {/* Rotas para Impressos */}
            {permissoes.includes("c-impr") && (
              <Route path="impresso">
                <Route path=":clienteId">
                  <Route index element={<NewImpresso />} />
                </Route>
              </Route>
            )}

            {/* Rotas para Stocks */}
            {permissoes.includes("r-paSt") && (
              <Route path="stock">
                <Route index element={<Stock />} />
              </Route>
            )}

            <Route path="releasenotes">
              <Route index element={<ReleaseNotes />} />
            </Route>

            {/* Rotas para Logs */}
            {(userRole === "Gerente" ||
              userRole === "Médico/Administrador") && (
              <Route path="logs">
                <Route index element={<Logs />} />
              </Route>
            )}

            {/* Rotas para Utilizadores */}
            <Route path="users">
              {(userRole === "Médico/Administrador" ||
                userRole === "Gerente") && <Route index element={<Users />} />}

              <Route path=":userId">
                <Route path="perfil" element={<SingleUser title="Usuário" />} />
                {/* {(userRole === "Médico/Administrador" ||
                  userRole === "Gerente") && (
                  <Route
                    path="edit"
                    element={<EditUser title="Editar Usuário" />}
                  />
                )} */}
              </Route>
              {/* {(userRole === "Médico/Administrador" ||
                userRole === "Gerente") && (
                <Route
                  path="new"
                  element={<NewUser title="Adicionar Novo Usuário" />}
                />
              )} */}
            </Route>

            <Route path="/admin/whatsapp" element={<WhatsAppManager />} />
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </>
      ) : (
        // </Suspense>
        <>
          <Route path="/" element={<Auth />} />
          <Route path="/auth" element={<Auth />} />
        </>
      )}
    </Routes>
  );

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: !!token,
        token: token,
        userId: userId,
        image: image,
        login: login,
        logout: logout,
        role: userRole,
        listaRoles: listaRoles,
        usuariosAssociados: usuariosAssociados,
        secretariasDoMedico: secretariasDoMedico,
        assistentesDoMedico: assistentesDoMedico,
        perm: permissoes,
        nome: nome,
        genero: genero,
        playNotificationSound: playNotificationSound,
        estabelecimento: estabelecimento,
        atualizarEstabelecimento: atualizarEstabelecimento,
        nomeAbreviado: nome
          ? nome.split(/\s+/)[0] +
            " " +
            nome.split(/\s+/)[nome.split(/\s+/).length - 1]
          : "",
      }}
    >
      <VersionCheckProvider>
        <ClinicaContext.Provider
          value={{
            clinica,
            configuracoes,
            setConfiguracoes,
          }}
        >
          <ContingenciaEfaturaProvider>
            <ActiveDoctorsProvider>
              <NotificationsProvider>
                <LoadingProvider>
                  <WebSocketProvider>
                    <ChatProvider>
                      <TutorialProvider>
                        <div className="app">
                          <BrowserRouter>
                            {/* Acima das rotas, para a faixa das urgencias
                                aparecer em TODOS os ecras. Dentro do router
                                porque precisa dos links da lista. */}
                            <BarraUrgencias />
                            {routes}
                          </BrowserRouter>
                          <LoadingSpinner />
                        </div>
                      </TutorialProvider>
                    </ChatProvider>
                  </WebSocketProvider>
                </LoadingProvider>
              </NotificationsProvider>
            </ActiveDoctorsProvider>
          </ContingenciaEfaturaProvider>
        </ClinicaContext.Provider>
      </VersionCheckProvider>
    </AuthContext.Provider>
  );
}

export default App;
